// extracted by mini-css-extract-plugin
export default {"Files":"Files_Files__jLJXH","search":"Files_search__jnMHh","file":"Files_file__BViya","info":"Files_info__KQszg","fileType":"Files_fileType__O+DEv"};